import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button, Dialog } from 'vnetwork-ui'

interface CreateFeedbackTokenModalProps {
    open: boolean
    onClose: () => void
    onSubmit: (data: {
        recipient_name?: string
        recipient_email?: string
        recipient_phone?: string
    }) => Promise<void>
    isLoading: boolean
}

interface FormValues {
    recipient_name: string
    recipient_email: string
    recipient_phone: string
}

const CreateFeedbackTokenModal: React.FC<CreateFeedbackTokenModalProps> = ({
    open,
    onClose,
    onSubmit,
    isLoading,
}) => {
    const { t } = useTranslation()
    const { handleSubmit, reset } = useForm<FormValues>({
        defaultValues: {
            recipient_name: '',
            recipient_email: '',
            recipient_phone: '',
        },
    })

    const handleFormSubmit = async (data: FormValues) => {
        await onSubmit({
            recipient_name: data.recipient_name || undefined,
            recipient_email: data.recipient_email || undefined,
            recipient_phone: data.recipient_phone || undefined,
        })
        reset()
    }

    const handleClose = () => {
        reset()
        onClose()
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            title={t('feedback-create-token-title')}
            maxWidth="sm"
        >
            <form
                onSubmit={handleSubmit(handleFormSubmit)}
                className="space-y-4 p-4"
            >
                <p className="text-sm text-gray-600 mb-4">
                    {t('feedback-create-token-description')}
                </p>
                <div className="flex justify-end gap-2 pt-4 border-t">
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                        disabled={isLoading}
                    >
                        {t('cancel')}
                    </Button>
                    <Button
                        variant="contained"
                        type="submit"
                        disabled={isLoading}
                    >
                        {isLoading ? t('creating') : t('create')}
                    </Button>
                </div>
            </form>
        </Dialog>
    )
}

export default CreateFeedbackTokenModal
